import React, { useEffect, useState } from "react";
import copertina from "../../images/home/Orario_natalizio.jpg";
import foto1 from "../../images/home/IMG_8672-2.jpg";
import foto2 from "../../images/Danza/35e41744-8368-4fd2-923b-cfc7d33f8ee9-3.jpg";
import foto3 from "../../images/Palestra/IMG_9287-4.jpg";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./CaroselloHome.css";
import {url} from "inspector";

interface CaroselloHomeProps {}

function CaroselloHome(_: CaroselloHomeProps) {
    const navigate = useNavigate();


    return (
        <div>
            <Helmet>
                <title>Il Cigno</title>
                <meta name="description" content="Piscina, Palestra, Danza, Fitness, Runnering, SPA" />
                {/* Precarica l'immagine LCP */}
                <link rel="preload" as="image" href={foto1} />
            </Helmet>

            <div id="carouselExampleAutoplaying" className="carousel slide my-carousel-home" data-bs-ride="carousel">
                <div className="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide-to="2" aria-label="Slide 3"></button>
                </div>

                <div className="carousel-inner">
                    <div className="carousel-item my-carousel-home active">
                        <section
                            className="titolo-section-home"
                            style={{ backgroundImage: foto1, width: "100%" }}
                        >
                            <div className="overlay"></div>
                            <h1 className="carousel-caption my-carousel-title">
                                CENTRO SPORTIVO <br/> IL CIGNO
                            </h1>
                        </section>
                    </div>

                    {/* <div className="carousel-item my-carousel-home active">
                        <img style={{cursor: "pointer"}} onClick={() => navigate("./news/orario_natalizio")} src={copertina} loading="lazy" className="d-block w-100" alt="Danza" />
                        <div className="carousel-caption d-none d-md-block"></div>
                    </div>*/}

                    <div className="carousel-item my-carousel-home">
                        <img src={foto2} loading="lazy" className="d-block w-100" alt="Danza" />
                        <div className="carousel-caption d-none d-md-block"></div>
                    </div>

                    <div className="carousel-item my-carousel-home">
                        <img src={foto3} loading="lazy" className="d-block w-100" alt="Piscina" />
                        <div className="carousel-caption d-none d-md-block"></div>
                    </div>
                </div>

                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>

                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </div>
    );
}

export default CaroselloHome;
